import React, {Component} from 'react';
import { Form,Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import axios from 'axios';

import {
    BACKEND_URL
} from '../../config.js';

class LinkToc extends Component {

      state = {
          bis_report_list: [],
          isLoading: false,
          selected: null

      }

      componentDidMount() {
          this.getReportList()
      }

      onChange =(selected)=> {
          this.setState(selected)
          if(selected.length > 0) {
              this.setState({ bis_id: selected[0].Id })
          } else {
             this.setState({ bis_id: null }) 
          }
      }

      handleSave = ()=> {
          this.props.onSubmit(this.state.bis_id)
      }

      getReportList = ()=> {
        this.setState({isLoading: true})
        axios.get(
          BACKEND_URL + "/v1/explore/bis_list", {
              headers: {
               token: localStorage.getItem("token")
             }
          }
        ).then((res) => {
            console.log(res)
            this.setState({bis_report_list: res.data.result, isLoading: false})
        }).catch((err) => {
            this.setState({isLoading: false})
            alert("Something Went Wrong!")
            console.log(err)
        })
      }
        
    render(){
        return(
            <div>
                {  this.state.isLoading ? <div>Loading List, Please Wait.....</div> :
                    <div>
                        <Typeahead
                          style={{border: '1px solid #ccc', padding: '12px 20px', margin: '8px 0'}}
                          autoFocus={true}
                          placeholder="Please select from list"
                          id="toc-bis"
                          labelKey="Title"
                          onChange={(selected) => this.onChange(selected)}
                          options={this.state.bis_report_list}
                          selected={this.state.selected}
                        />
                        <Button disabled={this.state.bis_id == null} varient="primary" onClick={this.handleSave}>
                                 { this.state.bis_id == null ? 'Choose One' : 'Update Now' }
                        </Button>
                    </div>
                }
            </div>
        )
    }
} 


export default LinkToc;


// WEBPACK FOOTER //
// ./src/components/LinkToc/linkToc.jsx